'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('voting-show', {
      url: '/voting/:id',
      template: '<voting-show></voting-show>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/voting/voting-show/voting-show.routes.js